import reduceReducers from "reduce-reducers";

import {
  FEATURE_FLAGS_FETCH_SUCCESS,
  FEATURE_FLAGS_FETCH_FAILURE,
} from "./actions";

const initialState = {
  flags: {},
};

function setFeatureFlagsReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case FEATURE_FLAGS_FETCH_SUCCESS:
      return { ...state, flags: payload };

    case FEATURE_FLAGS_FETCH_FAILURE:
      console.error("Failed to fetch feature flags", payload);
      return { ...state, ...initialState };

    default:
      return state;
  }
}

const featureFlagsReducer = reduceReducers(setFeatureFlagsReducer);

export { featureFlagsReducer };
